import { MenuBottom } from "../blocks/MenuBottom/MenuBottom";
import Header from "../components/header/header";

import { UslugaFindByUrlResponse } from "@project/shared-types";
import { useEffect, useState } from "react";
import { useLocation } from 'react-router';
import { Footer } from "../blocks/Footer/Footer";
import { WorkPromo } from "../blocks/workpromo/workpromo";
import { ScrollBlock } from "../components/others/ScrollBlock";
import "../core/core.css";
import { GetProductByServiceUrlAPI } from '../entities/service/model/products.api';
import { BlocksBuilder } from "../features/service-details/ui/BlocksBuilder";
import { Services } from "../features/service-list/ui/Services";

const Usluga = () => {
  const [data, setData] = useState<UslugaFindByUrlResponse | null>(null);
  const location = useLocation();
  useEffect(() => {
    const fetchData = async () => {
      const data = await GetProductByServiceUrlAPI({ service_url: location.pathname });
      setData(data);
    };
    fetchData();
  }, [location]);
  return (
    <>
      {data && (
        <>
          <title>{data.page?.title}</title>
          <link rel="canonical" href={`https://hmrep.ru/uslugi/${data.page?.url}`} />
          <meta name="description" content={data.page?.description} />
          <meta property="og:title" content={data.page?.title} />
          <meta property="og:description" content={data.page?.description} />
        </>
      )}
      <div className="body">
        <ScrollBlock></ScrollBlock>
        <div className="blocks">
          <Header></Header>
          {data && <BlocksBuilder data={data}></BlocksBuilder>}
          {data && (
            <Services
              exclude_ids={
                data.usluga?.product_id ? [data.usluga?.product_id] : []
              }
            ></Services>
          )}
          <WorkPromo></WorkPromo>
          <Footer></Footer>
        </div>
        <MenuBottom></MenuBottom>
      </div></>
  );
};
export default Usluga;
